module.exports = __webpack_public_path__ + "static/media/a3.68b5887c.png";